import { render, staticRenderFns } from "./SurgeryPrint.vue?vue&type=template&id=f7a4b75c&"
import script from "./SurgeryPrint.vue?vue&type=script&lang=js&"
export * from "./SurgeryPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports